import { videoEventBus } from "../videoEventBus";

/**
 * Hook for tracking error-related analytics events
 */
export const useErrorAnalytics = () => {
  /**
   * Track when an error occurs in video chat
   * @param errorType - The type of error that occurred
   */
  const handleError = (errorType: string) => {
    videoEventBus.emitEvent("videochat:error", { errorType });
  };

  return {
    handleError,
  };
}; 